import { Module } from 'vuex';

import { crmTasksService } from '@/services/crm-tasks/crm-tasks.service';
import { CrmTaskCounters } from '@/services/crm-tasks/crm-tasks.types';
import { RootState } from '@/store';

export interface CrmTaskState {
  counters: CrmTaskCounters;
}

const state: CrmTaskState = {
  counters: { overdue: 0, due_today: 0, upcoming: 0, no_due_date: 0 }
};

const options: Module<CrmTaskState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    /* Rafraîchit les compteurs du badge de la cloche (appelé par polling et après chaque
     * action sur une tâche). Les erreurs sont silencieuses : un échec de polling ne doit
     * pas générer d'alerte. */
    refreshCounters: ({ commit }): Promise<void> => {
      return crmTasksService
        .counters()
        .then(counters => commit('counters', counters))
        .catch(() => undefined);
    }
  },
  mutations: {
    counters: (state, counters: CrmTaskCounters) => (state.counters = counters)
  }
};

export default options;
